import axios from "@/axios.js"

export default {
 searchMail({
   commit
 }, payload) {
   return new Promise((resolve, reject) => {
     axios.get("/api/v2/admin/search/user-email/"+ payload)
     .then((response) =>{
       if(response.data.result == 'success'){
         commit("SET_EMAIL_LIST", response.data.data)
         resolve(response)
       }
       reject(resolve)
     }).catch((error) => {
       reject(error)
     })
   })
 },

 searchLevel({
   commit
 }, payload) {
   return new Promise((resolve, reject) => {
     axios.get("/api/v2/admin/search/user-level/"+ payload)
     .then((response) =>{
       if(response.data.result == 'success'){
         commit("SET_LEVEL_LIST", response.data.data_list)
         resolve(response)
       }
       reject(resolve)
     }).catch((error) => {
       reject(error)
     })
   })
  },

 searchId({ commit }, payload) {
   return new Promise((resolve, reject) => {
     axios.get("/api/v2/admin/search/user-uuid/"+ payload)
     .then((response) =>{
       if(response.data.result == 'success'){
         commit("SET_ID_LIST", response.data.data)
         resolve(response)
       }
       reject(resolve)
     }).catch((error) => {
       reject(error)
     })
   })
 },

 updateUserinfo({
   commit
 }, payload) {
   return new Promise((resolve, reject) => {
     axios.put("/api/v2/admin/user-level-point", payload)
       .then((response) => {
         if (response.data.result == 'success') {
           commit('UPDATE_USER_LIST', response.data.data)
           resolve(response)
         }
         reject(response)
       })
       .catch((error) => {
         reject(error)
       })
   })
 },

}
